module.exports = __webpack_public_path__ + "img/WizardRiches_EGM.1eedd04a.jpg";